<template>
  <section
    id="contact"
    class="relative">
    <div
      class="app-section app-container relative max-w-224">
      <BaseTitle>
        Get in <span>Touch</span>
      </BaseTitle>

      <p class="mt-6 text-center">
        Have questions or want to learn more? Contact us today to discuss how we can enhance your developer experience.
      </p>
      <BaseBtn
        class="mt-14"
        tag="a"
        href="/register"
        target="_blank">
        Get in Touch
      </BaseBtn>
      <span class="absolute -bottom-40 -right-60 hidden xl:block">
        <object
          type="image/svg+xml"
          data="/images/animations/badge-02.svg"
          class=" w-48 shrink-0" /></span>
    </div>
    <span class="absolute -left-20 top-0 hidden xl:block">
      <object
        type="image/svg+xml"
        data="/images/animations/badge-01.svg"
        class=" w-68 shrink-0" /></span>
  </section>
</template>
